import { Tabs, TabsProps } from '@mantine/core';

import classNames from './Tabs.module.scss';

/** @deprecated Use `TabsProps` from `@zorro/design-system/v2/Tabs` instead */
export type ITabsProps = TabsProps;

/** @deprecated Use `Tabs` from `@zorro/design-system/v2/Tabs` instead */
export function ZorroTabs({ ...props }: ITabsProps) {
  return <Tabs classNames={classNames} {...props} />;
}

ZorroTabs.List = Tabs.List;
ZorroTabs.Tab = Tabs.Tab;
ZorroTabs.Panel = Tabs.Panel;
